import ErrorBoundary from "antd/es/alert/ErrorBoundary";
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PublicAuths = () => {
  const isAuthenticated = () => {
    const user = JSON.parse(localStorage.getItem("login"));
    // const user = true;
    if (user) return true;
    return false;
  };
  return isAuthenticated() ? (
    <Navigate to="/dashboard" />
  ) : (
    <ErrorBoundary>
      <Outlet />
    </ErrorBoundary>
  );
};

export default PublicAuths;
